import { generateClasses } from "../../utilities/components/styles";
var Styles = function () { return ({
    journeyLoader: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center'
    },
    loadingWrapperContainer: {
        position: "relative",
        width: "100%"
    },
    loadingOverlay: {
        position: "absolute",
        height: "100%",
        width: "100%",
        zIndex: 2,
        minHeight: 100
    },
    childrenOverlay: {
        filter: "blur(2px)",
        opacity: "0.8"
    }
}); };
export var getStyles = generateClasses(Styles);
